
import Stickyfill from "../assets/js/sticky.polyfill"

export default {
    methods:{
        initStickyForIE(stickyElm){
            Stickyfill.addOne(stickyElm);
            const observer = new IntersectionObserver(
                ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
                {threshold: [1]}
            );
            observer.observe(stickyElm)
        }
    },

}